// Action categories for better organization
export const ACTION_CATEGORIES = {
    ELEMENT_CREATE: 'element.create',
    ELEMENT_DELETE: 'element.delete',
    ELEMENT_MOVE: 'element.move',
    ELEMENT_RESIZE: 'element.resize',
    ELEMENT_PROPERTY: 'element.property',
    SCREEN_CREATE: 'screen.create',
    SCREEN_DELETE: 'screen.delete',
    SCREEN_PROPERTY: 'screen.property',
    EXPERIENCE_PROPERTY: 'experience.property',
    CANVAS_OPERATION: 'canvas.operation',
} as const;

export type ActionCategory =
    (typeof ACTION_CATEGORIES)[keyof typeof ACTION_CATEGORIES];

export interface UndoRedoAction {
    id: string;
    timestamp: number;
    description: string;
    category: ActionCategory;
    targetId?: string; // ID of the affected element/screen
    targetName?: string; // Human-readable name
    changes: PropertyChange[];
    execute: () => void;
    undo: () => void;
}

export interface PropertyChange {
    path: string; // e.g., 'metadata.text', 'displayProperties.backgroundColor'
    oldValue: any;
    newValue: any;
    displayName: string; // e.g., 'Text Content', 'Background Color'
}

export interface UndoRedoState {
    history: UndoRedoAction[];
    currentIndex: number; // -1 means at the latest state
    maxHistorySize: number;
    isUndoing: boolean;
    isRedoing: boolean;
}

export interface HistoryEntry {
    action: UndoRedoAction;
    isActive: boolean; // Currently at this point in history
    canUndoTo: boolean; // Can undo to this point
    canRedoTo: boolean; // Can redo to this point
}

// Debouncing configuration
export interface DebounceConfig {
    delay: number; // milliseconds
    maxWait?: number; // maximum time to wait before forcing execution
    groupByTarget: boolean; // group changes to the same target
}

// Helper types for creating actions
export interface CreateActionParams {
    category: ActionCategory;
    description: string;
    targetId?: string;
    targetName?: string;
    changes: PropertyChange[];
    execute: () => void;
    undo: () => void;
}
